import { FallbackUiTranslation } from '@/assets/locales/components/falbackUi/fallbackUi.translation.en.ts';

export const fallbackUiTranslation: FallbackUiTranslation = {
  title: 'Ooops! Coś poszło nie tak.',
  message: 'Nie udało nam się pobrać danych',
  instruction:
    'Spróbuj ponownie wykonać operację. Jeśli błąd będzie się powtarzał, prosimy o email na adres: {{supportEmail}} z szczegółami.',
};
